import React, { Fragment } from 'react';
import MahasulEntryMasterFormView from '../../../components/account/create/mahasul_entry/MahasulEntryMasterFormView';

const MahasulEntryCreateListView = () => {
  return (
    <Fragment>
      <MahasulEntryMasterFormView />
    </Fragment>
  )
}

export default MahasulEntryCreateListView